var map = {
	"./CMS.svg": 30133,
	"./Manage_Admin.svg": 2143,
	"./Manage_Roles.svg": 48597,
	"./icon-dashboard.svg": 16510,
	"./setting.svg": 31270,
	"./subscription.svg": 85249,
	"./support.svg": 71703,
	"./test.svg": 50834,
	"./user.svg": 21755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16400;